import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---------- Auth ----------
export async function me() { return (await api.get("/auth/me")).data; }
export async function exchangeSession(session_id) { return (await api.post("/auth/session", { session_id })).data; }
export async function logout() { return (await api.post("/auth/logout")).data; }
export async function registerEmail(payload) { return (await api.post("/auth/register", payload)).data; }
export async function loginEmail(payload) { return (await api.post("/auth/login", payload)).data; }
export async function googleCodeExchange(code) {
  return (await api.post("/auth/google/code", { code }, {
    headers: { "X-Requested-With": "XmlHttpRequest" },
  })).data;
}

// ---------- Accounts ----------
export async function listAccounts() { return (await api.get("/accounts")).data; }
export async function createAccount(payload) { return (await api.post("/accounts", payload)).data; }
export async function updateAccount(account_id, payload) { return (await api.patch(`/accounts/${account_id}`, payload)).data; }
export async function deleteAccount(account_id) { return (await api.delete(`/accounts/${account_id}`)).data; }

// ---------- Bills ----------
export async function listBills(account_id) {
  const q = account_id ? `?account_id=${account_id}` : "";
  return (await api.get(`/bills${q}`)).data;
}
export async function analyticsSummary(account_id) {
  const q = account_id ? `?account_id=${account_id}` : "";
  return (await api.get(`/analytics/summary${q}`)).data;
}
export async function uploadBill(file, account_id) {
  const fd = new FormData();
  fd.append("file", file);
  const q = account_id ? `?account_id=${account_id}` : "";
  return (await api.post(`/bills/upload${q}`, fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
}
export async function seedSample() { return (await api.post("/bills/seed-sample")).data; }
export async function deleteBill(bill_id) { return (await api.delete(`/bills/${bill_id}`)).data; }
export async function updateBill(bill_id, patch) { return (await api.patch(`/bills/${bill_id}`, patch)).data; }
export async function createBill(payload) { return (await api.post("/bills", payload)).data; }

// ---------- Public ----------
export async function publicSnapshot(share_id) {
  return (await api.get(`/public/snapshot/${share_id}`)).data;
}

// ---------- Admin ----------
export async function adminMe() { return (await api.get("/admin/me")).data; }
export async function adminSummary() { return (await api.get("/admin/summary")).data; }

// ---------- Peer comparison ----------
export async function analyticsCompare(account_id) {
  const q = account_id ? `?account_id=${account_id}` : "";
  return (await api.get(`/analytics/compare${q}`)).data;
}

// ---------- Admin users list ----------
export async function adminUsers() { return (await api.get("/admin/users")).data; }
